import React, { useState, useEffect } from 'react'
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function Form({ Page = "", is_edit = 0, edit_id = 0 }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [FormData, setFormData] = useState({});
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [IsEdit, setIsEdit] = useState(false);
    const [canView, setCanView] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const fetchOrganizationData = async () => {
        const filter = { id: store_data?.org_id }
        const response = await postAPI("/organization/fetchSingle", filter);
        setFormData({
            organization_logo: response?.data?.length == 0 ? '' : response?.data[0]?.organization_logo,
            reg_domain: response?.data?.length == 0 ? '' : response?.data[0]?.reg_domain,
            admin_panel: response?.data?.length == 0 ? '' : response?.data[0]?.admin_panel,
            user_panel: response?.data?.length == 0 ? '' : response?.data[0]?.user_panel,
            organization_website: response?.data?.length == 0 ? '' : response?.data[0]?.organization_website,
            organization_name: response?.data?.length == 0 ? '' : response?.data[0]?.organization_name,
            organization_email_id: response?.data?.length == 0 ? '' : response?.data[0]?.organization_email_id,
            organization_contact_number: response?.data?.length == 0 ? '' : response?.data[0]?.organization_contact_number,
            organization_address: response?.data?.length == 0 ? '' : response?.data[0]?.organization_address
        })
    }


    useEffect(() => {
        const checkPermissionsAndFetch = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanEdit(true);
                await fetchOrganizationData();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "General", "VIEW");
                const editAllowed = await hasPermission("SETTINGS", "General", "EDIT");
                setCanView(viewAllowed);
                setCanEdit(editAllowed);
                if (viewAllowed) {
                    await fetchOrganizationData();
                }
            }
            setTimeout(() => {
                setLoading(false)
            }, 1000)
        };
        checkPermissionsAndFetch();
    }, [Page])

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) {
            return;
        }
        if (!canEdit) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        const filter = { ...FormData, id: store_data?.org_id }
        const response = await postAPI("/organization/update", filter);
        console.log(FormData)
        if (response?.status) {
            setIsBTNClicked(false);
            toast.success('Great Job ! Your brand information has been updated.');
            setTimeout(() => {
                window.location.reload();
            }, 5000)
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Invalid Request. We cannot proceed with this request for now.');
        }
    }
    return (
        <>
            {
                Loading ?
                    <Loader />
                : !canView ?
                    <div className="text-center text-danger py-5">
                        <i className="fa fa-lock fa-3x mb-3"></i>
                        <h5>Access Denied</h5>
                        <p>You do not have permission to view this page.</p>
                    </div>
                    :
                    <>
                        {
                            !IsEdit ?
                                <>
                                    <div className='container-fluid'>
                                        <div className='row'>
                                            <div class="col-2 text-start mb-3">
                                                {/* <label>Organization Logo</label> */}
                                                <img src={`${getURL()}/${FormData?.organization_logo}`} alt="Organization Logo" class="img-fluid rounded mt-2" style={{ width: "120px" }} />
                                                    <button type="button" class="btn btn-primary mt-5" onClick={() => setIsEdit(true)}>Edit</button>
                                            </div>
                                            <div class="offset-md-2 col-8 text-center mb-3">
                                                <div className='row'>
                                                    <div class="col-6 text-start mb-3">
                                                        <label>Organization Name</label>
                                                        <h6 class="mt-2">{FormData?.organization_name}</h6>
                                                    </div>
                                                    <div class="col-6 text-start mb-3">
                                                        <label>Organization Email ID</label>
                                                        <h6 class="mt-2">{FormData?.organization_email_id}</h6>
                                                    </div>
                                                    <div class="col-6 text-start mb-3">
                                                        <label>Organization Contact Number</label>
                                                        <h6 class="mt-2">{FormData?.organization_contact_number}</h6>
                                                    </div>
                                                    <div class="col-6 text-start mb-3">
                                                        <label>Organization Website</label>
                                                        <h6 class="mt-2">{FormData?.organization_website}</h6>
                                                    </div>
                                                    <div class="col-12 text-start mb-3">
                                                        <label>Organization Address</label>
                                                        <h6 class="mt-2">{FormData?.organization_address}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div class="col-2 text-end mb-3">
                                                <div class="mt-4">
                                                    <button type="button" class="btn btn-primary" onClick={() => setIsEdit(true)}>Edit</button>
                                                </div>
                                            </div>
                                            <div class="col-6 text-start mb-3">
                                            </div> */}
                                        </div>
                                    </div>
                                </>
                                :
                                <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                                    <div class="col-12 col-md-12">
                                        <FileUploadHandler Name="organization_logo" form_data={FormData} setFormData={setFormData} error={Error} setError={setError} Section={Page} Label='Brand Logo' />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler is_disabled={true} form_data={FormData} setFormData={setFormData} Name="reg_domain" Type="text" Label="Application Domain" />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler is_disabled={true} form_data={FormData} setFormData={setFormData} Name="admin_panel" Type="text" Label="Admin Panel Domain" />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler is_disabled={true} form_data={FormData} setFormData={setFormData} Name="user_panel" Type="text" Label="User Panel Domain" />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler form_data={FormData} setFormData={setFormData} Name="organization_website" Type="text" Label="Brand Website" />
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <InputHandler form_data={FormData} setFormData={setFormData} Name="organization_name" Type="text" Label="Brand Name" />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler form_data={FormData} setFormData={setFormData} Name="organization_email_id" Type="text" Label="Brand Email ID" />
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <InputHandler form_data={FormData} setFormData={setFormData} Name="organization_contact_number" Type="text" Label="Brand Phone Number" />
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <NormalTextareaHandler form_data={FormData} setFormData={setFormData} Name="organization_address" Type="text" Label="Brand Address" />
                                    </div>
                                </FormSubmissionHandler>
                        }
                    </>
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
